import { registerAction } from '../../../Action'

const REMOVE_VIEW_FROM_STORE = 'REMOVE_VIEW_FROM_STORE'

const reducer = (state = {}, data) => ({
  ...state,
  entityDataByView: {
    ...state.entityDataByView,
    [data.payload.view]: undefined,
  },
})

const removeViewFromStore = registerAction(REMOVE_VIEW_FROM_STORE, { reducer })

export default removeViewFromStore
